var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _path5, _path6, _mask, _path7, _path8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 2,
    r: 1.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 1.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 1.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5L22.5 2.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 5.8406L22.9996 7.00138",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 37.6125L3 38C3 40.2091 4.79086 42 7 42H19C21.2091 42 23 40.2091 23 38V32.25M3 27.375L3 7C3 4.79086 4.79086 3 7 3H13M23 12.75V17.625",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 39,
    r: 1,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29H27C28.1046 29 29 28.1046 29 27V23C29 21.8954 28.1046 21 27 21H18C16.8954 21 16 21.8954 16 23V27C16 28.1046 16.8954 29 18 29H18.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29L16.5 32L21 29",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_3967_6294",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87868 10.7998C7.70711 11.9714 7.70711 13.8708 8.87868 15.0424L9.03617 15.1999L9.03519 15.2009L13.5915 19.7572L18.3047 15.044C19.4762 13.8725 19.4762 11.973 18.3047 10.8014L17.991 10.4877C16.8194 9.31616 14.9199 9.31616 13.7483 10.4877L13.5925 10.6436L13.435 10.4861C12.2634 9.31453 10.3639 9.31453 9.19236 10.4861L8.87868 10.7998Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87868 15.0424L8.17157 15.7495L8.17157 15.7495L8.87868 15.0424ZM8.87868 10.7998L8.17157 10.0927L8.17157 10.0927L8.87868 10.7998ZM9.03617 15.1999L9.74332 15.907L10.4503 15.1999L9.74327 14.4928L9.03617 15.1999ZM9.03519 15.2009L8.32804 14.4938L7.62102 15.2009L8.32808 15.908L9.03519 15.2009ZM13.5915 19.7572L12.8844 20.4643L13.5915 21.1714L14.2986 20.4643L13.5915 19.7572ZM18.3047 15.044L17.5976 14.3369L18.3047 15.044ZM18.3047 10.8014L19.0118 10.0943V10.0943L18.3047 10.8014ZM17.991 10.4877L17.2839 11.1948V11.1948L17.991 10.4877ZM13.7483 10.4877L13.0412 9.78063V9.78063L13.7483 10.4877ZM13.5925 10.6436L12.8854 11.3507L13.5925 12.0578L14.2996 11.3507L13.5925 10.6436ZM13.435 10.4861L12.7279 11.1932L12.7279 11.1932L13.435 10.4861ZM9.19236 10.4861L9.89946 11.1932L9.89946 11.1932L9.19236 10.4861ZM9.58579 14.3353C8.80474 13.5543 8.80474 12.2879 9.58579 11.5069L8.17157 10.0927C6.60948 11.6548 6.60948 14.1874 8.17157 15.7495L9.58579 14.3353ZM9.74327 14.4928L9.58579 14.3353L8.17157 15.7495L8.32906 15.907L9.74327 14.4928ZM9.74234 15.908L9.74332 15.907L8.32902 14.4928L8.32804 14.4938L9.74234 15.908ZM14.2986 19.0501L9.74229 14.4938L8.32808 15.908L12.8844 20.4643L14.2986 19.0501ZM17.5976 14.3369L12.8844 19.0501L14.2986 20.4643L19.0118 15.7512L17.5976 14.3369ZM17.5976 11.5085C18.3786 12.2896 18.3786 13.5559 17.5976 14.3369L19.0118 15.7512C20.5739 14.1891 20.5739 11.6564 19.0118 10.0943L17.5976 11.5085ZM17.2839 11.1948L17.5976 11.5085L19.0118 10.0943L18.6981 9.78062L17.2839 11.1948ZM14.4554 11.1948C15.2365 10.4138 16.5028 10.4138 17.2839 11.1948L18.6981 9.78062C17.136 8.21853 14.6033 8.21853 13.0412 9.78063L14.4554 11.1948ZM14.2996 11.3507L14.4554 11.1948L13.0412 9.78063L12.8854 9.93648L14.2996 11.3507ZM12.7279 11.1932L12.8854 11.3507L14.2996 9.93648L14.1421 9.77899L12.7279 11.1932ZM9.89946 11.1932C10.6805 10.4122 11.9468 10.4122 12.7279 11.1932L14.1421 9.77899C12.58 8.2169 10.0473 8.2169 8.48525 9.779L9.89946 11.1932ZM9.58579 11.5069L9.89946 11.1932L8.48525 9.779L8.17157 10.0927L9.58579 11.5069Z",
    fill: "white",
    mask: "url(#path-11-inside-1_3967_6294)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82252 23.4703C7.85059 23.9843 8.5 25.0351 8.5 26.1845V27.7802C8.5 28.7268 9.36599 29.4367 10.2942 29.2511L11.1944 29.071C12.2364 28.8626 13.1587 29.7739 12.9628 30.8183L12.3145 34.2764C12.1814 34.9859 11.562 35.5 10.8401 35.5H3.5V29.45C4.64112 29.2184 5.5 28.2095 5.5 27V24.2876C5.5 23.6083 6.21491 23.1665 6.82252 23.4703Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5,
    width: 3,
    height: 6,
    rx: 0.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcon);
export default __webpack_public_path__ + "static/media/socialMediaIcon.8ed9ff28a88ed60c57788c196745f97d.svg";
export { ForwardRef as ReactComponent };